const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC"
  ];
  
export default{
    convertDateFormat(inDate) {

        let dbDateTime = new Date(inDate);
        if(dbDateTime.getFullYear()==1){
          return null;
        }
      
        let formattedDate =
          dbDateTime.getDate() +
          "-" +
          months[dbDateTime.getMonth()] +
          "-" +
          dbDateTime.getFullYear();
        return formattedDate;
      },
      
      convertDateFormatYMD(inDate){
        let dbDateTime = new Date(inDate);
        let formattedDate = dbDateTime.getFullYear() + "-" + (dbDateTime.getMonth()+1) + "-" + dbDateTime.getDate();
        return formattedDate;
      }
}


// WEBPACK FOOTER //
// ./src/Formatter.js